export default {
  pageTitle: 'Package Information',
  waybill: 'Print Kilimall Waybill',
  waybillNumber: '国内运单号',
  logisticsCompany: 'Logistics Company',
  shoInformation: 'SHO Information',
  receiver: 'Receiver Information',
  fromWarehouse: 'From Warehouse',
  already: '已于',
  successSubmit: '提交交付完成',
  startShipment: '开始国内发货',
  placeholder1: '国内运单号',
  parcelDelivery: '请将包裹发送到指定中转仓',
  location: '所在地',
  transitName: '中转仓名称',
  person: '联系人',
  contactNumber: '联系电话',
  address: '收货地址',
  tips1: '请先将订单点击为开始发货，然后待订单包裹准备好后再开始本地派送。',
  startShipping: '开始发货',
  cancelShppidOrder: 'Cancel this shipped order',
  cancelOrder: 'Cancel the Confirmed Order',
  cancelStock: 'Cancel for No Stock',
  cancelOrder2: 'Cancel Order',
  addNumber: 'Add Global Logistic number',
  application: '订单交付完成申请',
  successd: '订单已交付完成',
  startDelivery: 'Start Local Delivery',
  tips2: 'Please enter Local logistics package number',
  closeOrder: 'Close Order',
  goodsDamaged: 'Goods damaged',
  goodsNotInApp: 'Goods is not same as in APP',
  customerNoReason: 'Customer rejected with no reason',
  packageRealStatus: 'Package Real Status',
  customerRejected: 'Customer rejected',
  customerAcceptedPackage: 'Customer accepted the package',
  noLogisticsRecord: 'No logistics record.',
  cancelConfirmation: 'Cancel confirmation',
  tips3: 'Order will be cancelled, do you want to continue ?',
  content1: '请选择要使用的尾程快递公司',
  content2: 'Please choose the delivery company',
  content3: '系统已经根据城市的配送情况做了默认配置，一般情况下无需更改，特殊情况下请手动指定快递服务商',
  type1: 'eCourier',
  type2: 'E-Desh (manually)',
  type3: '自配送',
  cod: 'COD',
  mpay: 'MPAY',
  startEnter: '开始填写面单',
  so: 'SO#',
  count: 'Count',
  package: 'Package#',
  tips4: 'The address cannot be found in the system.',
  type4: 'E-Desh NO.',
  remarks: '备注',
  // -----------------------------
  realStatus1: 'Shipped',
  realStatus2: 'In Delivery',
  realStatus3: 'Arrived',
  // -----------------------------
  orderconditions1: '中通',
  orderconditions2: '圆通',
  orderconditions3: '申通',
  orderconditions4: '韵达',
  orderconditions5: '百世',
  orderconditions6: '人人',
  orderconditions7: '顺丰',
  orderconditions8: '京东',
  orderconditions9: '其他',
  // --------------------
  storeIdMap1: 'TopSelective',
  storeIdMap2: 'FlyingGoods',
  storeIdMap3: 'Cost-effective',
  storeIdMap4: 'FashionMall',
  storeIdMap5: 'Digitone',
  storeIdMap6: 'FlashSK',
  // ------------------
  paymentMethodMap1: 'Online',
  paymentMethodMap2: 'COD',
  paymentMethodMap3: 'pre',
  // -----------------注：原文中确有两个In Delivery
  packageStatusMap1: 'Pending Dispatch',
  packageStatusMap2: 'In Transit',
  packageStatusMap3: 'In Delivery',
  packageStatusMap4: 'Completed',
  packageStatusMap5: 'In Delivery',
  packageStatusMap6: 'Cancel',
  packageStatusMap7: 'Rejected',
  packageStatusMap8: 'Back',
  // ---------------
  shipOrderStatusMap1: 'Collecting Goods',
  shipOrderStatusMap2: 'Collection Completed',
  shipOrderStatusMap3: 'Packaged',
  // -------------
  columnSHO1: 'SO#',
  columnSHO2: 'Ship Order',
  columnSHO3: 'Item',
  columnSHO4: 'Amount',
  columnSHO5: 'Status',
  columnSHO6: 'Seller Dispatch Time',
  columnSHO7: 'Package Complete Time',
  // -----------------
  columnReceipt1: 'User ID',
  columnReceipt2: 'Country',
  columnReceipt3: 'State',
  columnReceipt4: 'City',
  columnReceipt5: 'Area',
  columnReceipt6: 'Address',
  columnReceipt7: 'Receiver',
  columnReceipt8: 'Contact Phone',
  // -----------------
  tableColumnSku1: 'SKU#',
  tableColumnSku2: 'manufacture id',
  tableColumnSku3: 'Title',
  tableColumnSku4: 'Spec',
  tableColumnSku5: 'Price',
  tableColumnSku6: 'Discount',
  tableColumnSku7: 'Number',
  tableColumnSku8: 'Sub Total',
  tableColumnSku9: 'Weight',
  // -----------------
  columnShipPackage1: 'Package#',
  columnShipPackage2: 'Payment',
  columnShipPackage3: 'Early SHO Create',
  columnShipPackage4: 'User ID',
  columnShipPackage5: 'Due',
  columnShipPackage6: 'Online Pay',
  columnShipPackage7: 'Old Status',
  columnShipPackage8: 'Status',
  columnShipPackage9: 'Creat Time',
  columnShipPackage10: 'Print Time',
  columnShipPackage11: 'Delivery Time',
  columnShipPackage12: 'Close Time',
  columnShipPackage13: 'Logistics No.',
  reason1: 'Damaged',
  reason2: 'Discrepancy',
  reason3: 'No reason',
  print: 'Print',
  // -------------
  columnSku1: 'SKU#',
  columnSku2: 'Title',
  columnSku3: 'Spec',
  columnSku4: 'Price',
  columnSku5: 'Number',
  columnSku6: 'Sub Total',
  columnSku7: 'Weight',
  // ----------------------
  send1: '【2204】SMS turned off.',
  send2: '【2252】SMS failed to send.',
  errorTips1: '该商品从Dhaka退货仓发货，由Kilimall代处理',
  content_delivered1: 'Goods being delivered by',
  content_delivered2: '店铺自发货订单',
  content_delivered3: '平台承运',
  warningTips1: '请先在店铺设置中配置好发货地址',
  content4: '请选择快递！',
  content5: '请填写快递单号！',
  success1: 'Successfully!',
  content6: '请确认订单已自行或通过快递交付用户手中再执行此操作！',
  content7: 'Processing, please try again later.',
  errorTips: '备注信息不能超过20个字符！',
  content8: 'Please enter E_Desh Number.',
  content9: 'Please enter correct Number.',
  // -------------------------------------------------------------------
  // -------------------------------------------------------------------
  // 因命名时未考虑同名文件翻译不好处理 所有存在同名文件，现将其他名为_id的文件翻译也录在此处
  // fault-lisclaimer-list/_id.vue
  fl_pageTitle: 'Negligent record',
  fl_negligentRecordID: '过失记录ID',
  fl_punishID: '处罚ID',
  fl_all: 'All',
  fl_metaTitle: '过失与免责',
  fl_disclaimer: 'disclaimer',
  fl_deductionMargin: 'deductionMargin',
  fl_deduction: 'deductionInClearing',
  fl_recordID: '记录ID',
  fl_recordDate: '过失日期',
  fl_faultItem: '过失项',
  fl_faultName: '过失名',
  fl_faultDescription: '过失描述',
  fl_so: '源SO#',
  fl_punish: '处罚',
  fl_punishType: '处罚类型',
  fl_punishAcount: '处罚金额',
  // page-components\seller-center\marginrecord\negligent-record-detail.vue 为此页面组件 也暂时写在此处
  flc_title: 'Penalty details',
  flc_penaltyID: 'Penalty ID',
  flc_punishType: 'Type of punishment',
  flc_penaltyAmount: 'Penalty amount',
  flc_rmb: 'RMB',
  flc_relatedRecords: 'Related records',
  flc_originalOrder: 'Original order',
  flc_shop: 'Shop',
  // 卖家取消订单
  sle_selectcancel: 'Please choose or enter the reason for cancellation',
  sle_understock: 'Low Stock',
  sle_holidays: 'Cannot ship during holidays',
  sle_else: 'Other',
  sle_reason: 'Please enter the reason for cancellation',
  sle_hint: "Cancellation of the order will result defect of store, which will  may cause deduction of deposit. Please handle with caution. If the customer wants to cancel the order, it's better to let the customer issue the cancellation.",
  LogisticsNumber: 'Logistics side waybill number'
}
